
export interface FetchEvents {
  /** called once json file has been loaded and parsed */
  gotJson: (fileName: string, json: any) => void;
  /** called if something goes wrong */
  gotError: (fileName: string, message: string) => void;
}

/** fetch a json file, sending along events */
export async function fetchJson(fileName: string, events: FetchEvents): Promise<Response | void> {
  const req = new Request(fileName);
  return fetch(req)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => events.gotJson(fileName, data))
    .catch((error) => events.gotError(fileName, `${error}`));
}
